import type { InstanceLoadStatus } from "./types";

const getters = {
	// Модалка. Уведомления (Колокольчик)
	modalNotify: (state: { modalNotify: object }) => state.modalNotify,

	// Модалка. Профиль
	modalProfile: (state: { modalProfile: object }) => state.modalProfile,

	// Модалка с фильтрами для мобильных устройств
	modalMobileFilters: (state: { modalMobileFilters: object }) =>
		state.modalMobileFilters,

	// Модалка - Активировать канал
	modalActivateChannel: (state: { modalActivateChannel: object }) =>
		state.modalActivateChannel,

	// Тип устройства (desktop or mobile)
	getDevice: (state: { device: object }) => state.device,

	// Список инстансов
	getInstances: (state: { instances: object }) => state.instances,

	// Подробная информация об инстансе
	getInstance: (state: { instance: object }) => state.instance,

	/**
	 * Возвращает состояние запроса карточки из хранилища для выбора сообщения на странице.
	 */
	getInstanceLoadStatus(state: { instanceLoadStatus: InstanceLoadStatus }) {
		return state.instanceLoadStatus;
	},

	// Создание инстанса
	instanceCreateGetters: (state: { instanceCreateState: object }) =>
		state.instanceCreateState,

	// Переход на другую страницу
	redirectGetters: (state: { redirectState: object }) => state.redirectState,

	// Удаляем инстанс
	instanceDeleteGetters: (state: { instanceDeleteState: object }) =>
		state.instanceDeleteState,

	// Модалка. Получить QR код
	modalQrCodeGetters: (state: { modalQrCodeState: object }) =>
		state.modalQrCodeState,

	// Получить QR код
	qrCodeGetters: (state: { qrCodeState: object }) => state.qrCodeState,

	// Перезагружаем инстанс
	instanceRebootGetters: (state: { instanceRebootState: object }) =>
		state.instanceRebootState,

	// Logout instance
	instanceLogoutGetters: (state: { instanceLogoutState: object }) =>
		state.instanceLogoutState,

	// Сохраняем настройки
	instanceSetSettingsGetters: (state: { instanceSetSettingsState: object }) =>
		state.instanceSetSettingsState,

	// Модалка. Лог действий
	modalEventLogGetters: (state: { modalEventLogState: object }) =>
		state.modalEventLogState,

	// Лог действий
	eventLogGetters: (state: { eventLogState: object }) => state.eventLogState,

	// Лог действий. Запись события
	sendEventLogGetters: (state: { sendEventLogState: object }) =>
		state.sendEventLogState,

	// Список опций для покупок
	optionListGetters: (state: { optionListState: [] }) => state.optionListState,
};
export default getters;
